import { render } from "./BlogSingleView.vue?vue&type=template&id=70c9e7bd&scoped=true"
import script from "./BlogSingleView.vue?vue&type=script&lang=js"
export * from "./BlogSingleView.vue?vue&type=script&lang=js"

import "./BlogSingleView.vue?vue&type=style&index=0&id=70c9e7bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c9e7bd"]])

export default __exports__